export const Distance_Sales_Contract_URL =
  'https://www.synapsai.ai/agreements/distance-selling-contract';

export const Agreement_URL =
  'https://www.synapsai.ai/agreements/clarification-text';

export const Privacy_Policy_URL =
  'https://www.synapsai.ai/agreements/cookie-policy';
